import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { VisionStudioTabs } from "../../components";
import ImageGallery from "../ImageGalllery/Upload";
import Annotate from "../Annotate/updatedAnnotation";
// import Annotate from "../Annotate/fullCanvasAnnotation";
// import Annotate from "../Annotate/canvasZoomAnnotation";
import AnnotationClassification from "../AnnotationClassification/AnnotationClassification";
import Train from "../Train";
import Test from "../Test";
import { ProjectsProvider } from "./projectsContext";
import WorkFlow from "../Workflow/WorkFlow";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store/store";
import { fetchTasks, Task } from "../../store/slice/ProjectTasksSlice";
import { fetchProjectById } from "../../store/slice/projectHandler";
import { ProjectItem } from "../../types/interface";
import { loadProjectData } from "../../store/slice/UISlice";
import WorkFlowNew from "../Workflow/WorkFlowNew";

const Uplaod: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const { id } = useParams() as { id: string };
  const [tabValue, setTabValue] = useState<number>(0);
  const [isClassificationProject, setIsClassificationProject] = useState(false);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState<
    ProjectItem | undefined
  >(undefined);
  const [taskType, setTaskType] = useState("");

  useEffect(() => {
    const loadData = async () => {
      let selectedProject = null;
      let taskList: Task[] = [
        {
          id: "",
          name: "",
          description: "",
          trackObject: false,
          colour: "",
        },
      ];

      await dispatch(fetchTasks())
        .unwrap()
        .then((response) => {
          taskList = response;
        });

      try {
        const response = await dispatch(fetchProjectById(id)).unwrap();
        selectedProject = response;
        dispatch(loadProjectData(selectedProject));
      } catch (error) {
        console.error("Failed to fetch project:", error);
        return;
      }

      if (selectedProject) {
        setSelectedProjectDetails(selectedProject);
        const taskTypeId = selectedProject.taskTypeId;
        const task = taskList!.filter((task: any) => task.id === taskTypeId);

        setTaskType(task[0]?.name);
        if (
          task[0]?.name.toLowerCase() === "binary classification" ||
          task[0]?.name.toLowerCase() === "multi-class classification" ||
          task[0]?.name.toLowerCase() === "multi-label classification"
        ) {
          setIsClassificationProject(true);
        } else {
          localStorage.setItem("taskType", "");
        }
      }
    };

    loadData();
  }, [id]);

  const navigateToAnnotate = () => {
    setTabValue(2); // Update the tab index to Annotate
    localStorage.setItem("activeTab", "2");
  };

  return (
    <>
      <ProjectsProvider>
        {selectedProjectDetails && (
          <VisionStudioTabs
            tabValue={tabValue}
            setTabValue={setTabValue}
            tabsName={[
              {
                labelName: "Overview",
                componentName: (<WorkFlow id={id} taskType={taskType}
                // componentName: (<WorkFlowNew id={id}
                />
                ),
              },
              {
                labelName: "Upload",

                componentName: (
                  <ImageGallery
                    id={id}
                    onNavigateToAnnotate={() => navigateToAnnotate()}
                    isImageUploader={selectedProjectDetails?.isImageUpload}
                    isAnnotate={selectedProjectDetails?.isAnnotate}
                    isProjectOwner={selectedProjectDetails?.isProjectOwner}
                    taskType={taskType}
                  />
                ),
              },
              {
                labelName: "Annotate",
                componentName: isClassificationProject ? (
                  <AnnotationClassification id={id} taskType={taskType} />
                ) : (
                  <Annotate
                    id={id}
                    isAnnotate={selectedProjectDetails?.isAnnotate}
                    isProjectOwner={selectedProjectDetails?.isProjectOwner}
                  />
                ),
              },
              {
                labelName: "Train",
                componentName: (
                  <Train
                    id={id}
                    isProjectOwner={selectedProjectDetails?.isProjectOwner}
                    isTrainer={selectedProjectDetails?.isTrainer}
                  />
                ),
              },
              { labelName: "Test", componentName: <Test id={id} /> },
            ]}
          />
        )}
      </ProjectsProvider>
    </>
  );
};

export default Uplaod;
